import { yupResolver } from '@hookform/resolvers/yup'
import { newAppealState } from 'feature/appeals/redux/appealFormCreateSelector'
import { messages } from 'helpers/validationMessages'
import {
  Controller,
  FieldValues,
  FormProvider,
  SubmitHandler,
  useForm,
} from 'react-hook-form'
import { useAppSelector } from 'store/hooks'
import { TextField } from 'ui'
import * as yup from 'yup'

import {
  OrderManageFromFooter,
  OrderManageFromHeader,
} from '../OrderManageFromUi'

import style from './OrderManageFrom.module.scss'

type TMainOrderManage = {
  handleBack: () => void
  title: string
  description: string
  subtitle?: string
  textFieldLabel: string
  onSubmit: SubmitHandler<FieldValues>
  isLoading: boolean
}

const schema = yup.object().shape({
  comment: yup
    .string()
    .required(messages.required)
    .max(1000, messages.maxLength(100))
    .test('notOnlySpaces', messages.required, value => value.trim() !== ''),
  uid: yup.number(),
})

// форма отмены заявки и жалобы на диллера
export function OrderManageFrom({
  handleBack,
  title,
  subtitle,
  description,
  textFieldLabel,
  isLoading,
  onSubmit,
}: TMainOrderManage) {
  const { uid } = useAppSelector(newAppealState)

  const methods = useForm({
    defaultValues: {
      comment: '',
      uid: uid,
    },
    resolver: yupResolver(schema),
    mode: 'onChange',
  })

  const { handleSubmit, control, formState } = methods

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} className={style.orderManageForm}>
        <div>
          <OrderManageFromHeader
            title={title}
            subtitle={subtitle}
            description={description}
          />

          <Controller
            name='comment'
            control={control}
            render={({ field }) => (
              <TextField
                multiline
                minRows={4}
                maxRows={10}
                inputProps={{ maxLength: 1000, autoComplete: 'off' }}
                label={textFieldLabel}
                className={style.reasonFiled}
                data-testid='manage-form-comment'
                {...field}
              />
            )}
          />

          <Controller
            name='uid'
            defaultValue={uid}
            control={control}
            render={({ field }) => (
              <TextField type='hidden' className={style.hidden} {...field} />
            )}
          />
        </div>

        <OrderManageFromFooter
          isButtonDisabled={!formState.isValid || isLoading}
          isLoading={isLoading}
          handleBack={handleBack}
        />
      </form>
    </FormProvider>
  )
}
